<template>
  <span>
    <div class="page-level-functions">
      <action-button
        v-if="!computedReadonly"
        variant="success float-right ml-3"
        text="Someter"
        i="fas fa-flag-alt"
        @click="submit"
      />

      <b-dropdown
        v-if="hasDeterminatePermission && showButtons && requestId > 0"
        text="Determinar"
        variant="outline-success"
        class="float-right ml-3"
      >
        <template #button-content>
          <em class="fas fa-flag-alt mr-2" />
          Determinar
        </template>
        <b-dropdown-item
          v-if="canApprove"
          class="ddl-item"
          @click="showApproveUserPanel()"
        >
          <em class="fas fa-check-circle mr-2" style="color: #2db782" />
          Aprobar
        </b-dropdown-item>
        <b-dropdown-item
          v-if="canDeny"
          class="ddl-item"
          @click="showDenialCommentPanel(true)"
        >
          <em class="fas fa-ban mr-2" style="color: #c9545e" />
          Denegar
        </b-dropdown-item>
        <b-dropdown-item
          v-if="canCancel"
          class="ddl-item"
          @click="showCancelationCommentPanel(true, true)"
        >
          <em class="fas fa-times-circle mr-2" style="color: #c9545e" />
          Cancelar
        </b-dropdown-item>
      </b-dropdown>

      <action-button
        v-if="!showSearchUser && showButtons && requestId > 0"
        variant="success float-right ml-3"
        text="Búsqueda de Usuario"
        i="fas fa-search"
        @click="goToSearchUser()"
      />

      <action-button
        variant="outline-success float-right ml-3"
        text="Regresar"
        i="fas fa-arrow-circle-left"
        @click="$router.go(-1)"
      />
    </div>

    <hr class="page-level-functions-separator" />

    <search-user
      v-if="showSearchUser"
      title="Búsqueda de Usuario"
      :user-account="model"
      @on-close="onUserClose()"
    />

    <approve-user-callout
      v-if="approveModel.showPanel"
      ref="approveUserRef"
      v-model="approveModel"
      title="Información de aprobación"
      icon="fas fa-check"
      :disabled="isPanelReadOnly"
      @input="onApproveSave()"
      @on-cancel="onApproveCancel()"
    />

    <comment-callout
      v-if="commentModel.showPanel"
      :title="commentModel.title"
      :icon="commentModel.icon"
      :comment="commentModel.comment"
      :disabled="isPanelReadOnly"
      @on-save="onCommentSave($event)"
      @on-cancel="onCommentCancel()"
    />

    <div class="account-request">
      <section-title
        title="Información del Usuario"
        icon="fas fa-user-alt"
        class="ar_section-title"
        title-class="ar_section-title-info"
        container-class="ar_section-title-container"
      />
      <validation-observer ref="userInfo">
        <div class="general-info mb-4">
         <app-role-assignment
          ref="roleAssignment"
          :user="user"
          :selectable-apps="selectableApps"
          :readonly="computedReadonly"
          :data="model"
          :is-login-user-provider="isProvider"
          @getGeneralAccountInfo="getDataAccount"
          @changed="onRoleAssignmentChanged"
        />
          <section-title title="Información General de Cuentas" has-line />
          <div class="row mx-0 mt-n1">
            <div class="col-12 col-md-3 mb-3">
              <validation-provider rules="required" v-slot="{ errors }">
                <custom-input
                  v-model="model.name"
                  label="Nombre:"
                  maxlength="64"
                  :disabled="computedReadonly || canEdit"
                  :error="errors[0]"
                  custom-error-msg="El nombre es requerido."
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-1 mb-3">
              <custom-input
                v-model="model.initial"
                label="Inicial:"
                :disabled="computedReadonly || canEdit"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <validation-provider rules="required" v-slot="{ errors }">
                <custom-input
                  v-model="model.paternalLastName"
                  label="Primer Apellido:"
                  maxlength="64"
                  :disabled="computedReadonly || canEdit"
                  :error="errors[0]"
                  custom-error-msg="El primer apellido es requerido."
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <custom-input
                v-model="model.maternalLastName"
                label="Segundo Apellido:"
                maxlength="64"
                :disabled="computedReadonly || canEdit"
              />
            </div>
            <div class="col-12 col-md-4 mb-3">
              <validation-provider
                ref="ssnValidator"
                rules="ssn"
                v-slot="{ errors }"
                :custom-messages="{
                  ssn: 'El número de seguro social entrado no es valido.',
                }"
              >
                <custom-input
                  v-model="computedSsn"
                  label="Número Seguro Social:"
                  maxlength="11"
                  @change="inputHandle"
                  mask-type="Personalssn"
                  :disabled="computedReadonly || canEdit"
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <validation-provider
                ref="emailValidator"
                :rules="emailValidationRules"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'El correo electrónico es requerido.',
                  email: 'El correo electrónico no es válido.',
                  regex:
                    'El correo electrónico debe ser de la agencia de.pr.gov o miescuela.pr',
                }"
              >
                <custom-input
                  v-model="model.email"
                  type = "email"
                  label="Correo Electrónico:"
                  :disabled="computedReadonly"
                  :error="errors[0]"
                  @input="nospace(model.email)"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  completePhone: 'El número de contacto no es válido.',
                  required: 'El número de contacto es requerido.',
                }"
                name="validationCustomtPhone1"
                rules="completePhone|required"
              >
                <custom-input
                  id="CustomInputPhone1"
                  label="Número de Contacto:"
                  v-model="model.phone"
                  mask-type="Phone"
                  :disabled="computedReadonly"
                  :error="errors[0]"
                  placeholder="(___) ___-____"
                />
              </validation-provider>
            </div>
          </div>
        </div>

      </validation-observer>
    </div>
  </span>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import ApproveUserCallout from '@/views/userRequests/components/ApproveUserCallout.vue';
import CommentCallout from '@/views/userRequests/components/CommentCallout.vue';
import AppRoleAssignment from '@/components/common/user/AppRoleAssignment.vue';
import alert from 'utils/mixins/alert.mixin';
import { userMixin } from '@/modules/user/mixins/user.mixin.js';
import userRequestStatuses from '@/utils/constants/userRequestStatuses';
import eduespService from '@/services/eduesp';
import apps from '@/utils/constants/applicationIds';
import {
  submitUserRequest,
  getRequestAccountUser,
    getGeneralAccountData as _getGeneralAccountData,
  changeRequestStatus as _changeRequestStatus,
} from '@/modules/userRequest/api';
import deticketsService from '@/services/detickets';
import { addUserFromRequest } from '@/modules/users/api';
import { extend } from 'vee-validate';
import SearchUser from '../components/SearchUser.vue';
import Roles from '@/utils/constants/rolesIds';
import applicationIds from "@/utils/constants/applicationIds";
import { isValidSsn } from '@/utils/helpers/ssn';
import {getSysParamByName} from "@/modules/common/api";

extend('ssn', {
  validate: (value) => {
    if (!value) return false;

    const valueToValidate = value.replaceAll('-', '');
    return isValidSsn(valueToValidate);
  },
});

const maskSSN = (value) => {
  if (value) {
    return value.replace(new RegExp('.{5}(?=.{4}$)'), '***-**-');
  }
};

export default {
  name: 'UserAccountRequest',
  components: {
    SectionTitle,
    CustomInput,
    ActionButton,
    AppRoleAssignment,
    SearchUser,
    ApproveUserCallout,
    CommentCallout,
  },
  mixins: [alert, userMixin],
  data: () => ({
    user: {
      parentPortalInfo: {
        relationship: null,
        physicalAddressLine1: null,
        physicalAddressLine2: null,
        physicalAddressMunicipality: null,
        physicalAddressPostalCode: null,
        postalAddressLine1: null,
        postalAddressLine2: null,
        postalAddressMunicipality: null,
        postalAddressPostalCode: null,
        email: null,
        phone: null,
        provider: null,
      },
      deticketsInfo: {
        depts: []
      }
    },
    canEdit:false,
    showSearchUser: false,
    model: {
      name: null,
      initial: null,
      paternalLastName: null,
      maternalLastName: null,
      ssn: null,
      email: null,
      phone: null,
      statusId: null,
      username: null,
      userIsActive: null,
      authMode: null,
    },
    readonly: false,
    showButtons: true,
    ssnByInput:null,
    commentModel: {
      showPanel: false,
      requestStatus: null,
      title: '',
      icon: '',
      comment: '',
    },
    showCancelCommentPanel: false,
    approveModel: {
      username: null,
      authMode: null,
      showPanel: false,
    },
    dateobj:new Date(),
    allianceSchoolsIds: [],
    agencyEmailValidation:{
      selectedRoles: [],
      userLocations: [],
    },
  }),
  computed: {
    computedSsn: {
      get() {
        return this.computedReadonly ? maskSSN(this.model.ssn) : this.model.ssn;
      },
      set(val) {
        this.model.ssn = val;
      },
    },
    hasAnySchoolInAlliance() {
      const userLocations = this.agencyEmailValidation.userLocations;
      // if the user is a teacher and has a school that is not part of the school alliances
      const hasSchoolInAlliance = userLocations?.map(c => c.schoolId).some(x => this.allianceSchoolsIds.includes(x));
      
      return hasSchoolInAlliance;
    },
    isAgencyEmailNeeded() {
      const selectedRoles = this.agencyEmailValidation.selectedRoles ?? [];
      const roleIds = selectedRoles.map((x) => x.roleId.toUpperCase());
      
      const rolesWhichNeedAgencyEmailValidation = [
        Roles.Director,
        Roles.Maestro,
        Roles.MaestroItinerante,
        Roles.MaestroIngles,
        Roles.MaestroJornadaParcial,
      ];
      
      return rolesWhichNeedAgencyEmailValidation.some((roleId) => roleIds.includes(roleId));
    },
    emailValidationRules(){
      const rules = {
                  required: true,
                  email: true,
                  regex: /@(de.pr.gov|miescuela.pr)$/,
                };

      // if school is in alliance then they can write any custom email
      if(this.hasAnySchoolInAlliance || !this.isAgencyEmailNeeded)
        delete rules.regex;
              
      return rules;
    },
    requestId() {
      return Number(this.$route.params.id);
    },
    selectableApps() {
      return Object.values(applicationIds);
    },
    computedReadonly() {
      return Boolean(this.requestId) || this.readonly;
    },
    isPanelReadOnly() {
      return (
        this.model.statusId !== userRequestStatuses.Sometida &&
        !this.showCancelCommentPanel
      );
    },
    hasDeterminatePermission() {
      return this.userHasPermissions('security.user.determinate');
    },
    canApprove() {
      return (
        this.userHasPermissions('security.user.approve') &&
        this.model.statusId === userRequestStatuses.Sometida
      );
    },
    canDeny() {
      return (
        this.userHasPermissions('security.user.deny') &&
        this.model.statusId === userRequestStatuses.Sometida
      );
    },
    canCancel() {
      return (
        this.userHasPermissions('security.user.cancel') &&
        this.model.statusId !== userRequestStatuses.Cancelada
      );
    },
    isTeacher() {
      const teacherRoles = [Roles.Maestro];

      // If it has roles and one of them is "Maestro", then it's a teacher
      return (
        this.user?.roles &&
        this.user?.roles?.some((x) =>
          teacherRoles.includes(x.roleId.toUpperCase())
        )
      );
    },
    isProvider() {
      const providerRoles = [Roles.Proveedor];
      return providerRoles.includes(this.userRoleId.toUpperCase());
    },
  },
  async created() {
    await this.getRequestInfo();

    const { data } = await getSysParamByName({
      parameterNames: [
        'AllianceSchoolsIds'
      ],
    });
    this.allianceSchoolsIds = data[0].staticValue.split(',').map(x => Number(x))
  },
  methods: {
    onRoleAssignmentChanged(){
        const roleAssignmentRef = this.$refs.roleAssignment ?? {};
        const selectedRoles = roleAssignmentRef?.user?.roles ?? [];
        const userLocations = roleAssignmentRef?.academicProfile?.userLocations;

        this.agencyEmailValidation.selectedRoles = selectedRoles
        this.agencyEmailValidation.userLocations = userLocations
    },
    async getRequestInfo() {
      if (!this.requestId) return;

      const { data } = await getRequestAccountUser(this.requestId);

      this.model = {
        ...data,
        id: data.id,
        userId: data.userId,
        name: data.firstName,
        initial: data.middleName,
        paternalLastName: data.lastPaternalName,
        maternalLastName: data.lastMaternalName,
        ssn: data.socialSecurityNumber,
        email: data.email,
        phone: data.contactPhone,
        statusId: data.statusId,
        username: data.username,
        userIsActive: data.userIsActive,
        authMode: data.authentication,
      };

      this.user = {
        roles: [],
        profile: {
          eduespPositionCode: data.position?.id,
          eduespPositionName: data.position?.name,
          teachPositionNo: data.positionNumber,
          staffId: data.kronosNumber,
          userLocations: [],
        },
        parentPortalInfo: data.parentPortalInfo,
        deticketsInfo: data.deticketsInfo,
      };

      this.approveModel.username = data.username;
      this.approveModel.authMode = data.authentication;
      this.commentModel.comment = data.reason;
      switch (this.model.statusId) {
        case userRequestStatuses.Aprobada:
          this.showApproveUserPanel();
          this.showButtons = true; // You can cancel after approved
          break;
        case userRequestStatuses.Denegada:
          this.showDenialCommentPanel();
          this.showButtons = true; // You can cancel after denial
          break;

        case userRequestStatuses.Cancelada:
          this.showCancelationCommentPanel();
          break;
      }

      this.commentModel.showPanel =
        this.model.statusId === userRequestStatuses.Denegada ||
        this.model.statusId === userRequestStatuses.Cancelada;

      data.requestRoleApplications.forEach((role) => {
        this.user.profile.userLocations.push(...role.requestProfileLocation);
        this.user.roles.push({
          applicationId: role.applicationId,
          applicationDisplayName: role.applicationDisplayName,
          roleName: role.roleName,
          roleId: role.roleId,
          accessLevel: role.accessLevel,
        });
      });
    },
    nospace(e){
      this.model.email = e?.trim()
    },
    async getDataAccount(info){
     if(!this.isTeacher){
      return
     }

     try {
        const { data } = await _getGeneralAccountData(info);
        this.model.name = data.firstName;
        this.model.initial = data.middleName;
        this.model.paternalLastName = data.lastPaternalName;
        this.model.maternalLastName = data.lastMaternalName;
        this.model.socialSecurityNumber = data.socialSecurityNumber;
        this.model.phone = data.contactPhone;
        this.model.positionNumber=data.positionNumber;
        this.model.employee=data.kronosNumber;
        this.canEdit = true;
        this.model.ssn = data.socialSecurityNumber;
      } catch (error) {
          this.Toast('Alerta',"Favor de comunicarse con en el administrador para la creación.",'error')
      }
    },
     inputHandle(ev){
      let ssnWithoutHyphens = ev.replace(/-/g, "");
      this.ssnByInput=ssnWithoutHyphens
      if(!this.ssnByInput || this.ssnByInput.length <= 8) return;
      let dataTosend ={
        socialNumber: this.ssnByInput,
        from: "SocialNumber"
      };
      this.getDataAccount(dataTosend);
    },
    goToSearchUser() {
      this.showSearchUser = true;
      this.showButtons = false;
    },
    onUserClose() {
      this.showSearchUser = false;
      this.showButtons = true;
    },
    async submit() {
      const profiles = this.$refs.roleAssignment?.getMipeProfile();

      await this.$nextTick(async () => {
        const valid = await this.$refs.userInfo.validate();
        const isPositionFormValid =
          await this.$refs.roleAssignment?.$refs.positionAssigment?.$refs.profileVO.validate();

        if (!valid || (isPositionFormValid != undefined && !isPositionFormValid)) {
          this.AlertValidationError();
          return;
        }

        const requestRoleApplications = this.user.roles.map((r) => ({
          applicationId: r.applicationId,
          roleId: r.roleId,
          requestProfileLocation:
            r.applicationId.toUpperCase() == apps.financePortal
              ? profiles.providerLocations?.map((l) => ({
                  companyId: l.companyId,
                }))
              : profiles.academicLocations?.map((l) => ({
                  centerId: l.centerId,
                  municipalityId: l.municipalityId,
                  regionId: l.regionId,
                  schoolId: l.schoolId,
                  districtId: l.districtId,
                })),
        }));

        const studentsSie = this.$refs.roleAssignment.$refs.parentProfile?.model.selectedStudents.map(x => x.studentSieId);

        const params = {
          requestRoleApplications,
          firstName: this.model.name,
          middleName: this.model.initial,
          lastPaternalName: this.model.paternalLastName,
          lastMaternalName: this.model.maternalLastName,
          socialSecurityNumber: this.model.ssn?.replaceAll('-', ''),
          email: this.model.email,
          contactPhone: this.model.phone,
          positionId: profiles.eduespPositionCode,
          positionNumber: profiles.teachPositionNo,
          kronosNumber: profiles.staffId,
          studentsSie: studentsSie,
          parentPortalInfo: this.user.parentPortalInfo,
          DeticketsPortalInfo: this.user.deticketsInfo,
        };

        try {
          await submitUserRequest(params);
          this.readonly = true;
          this.Toast(
            'Aviso',
            'La solicitud ha sido sometida exitosamente.',
            'success'
          );
        } catch (err) {
          this.Toast(
              'Error',
              err.response?.data?.message ?? 'Error inesperado.',
              'error'
            );
        }
      });
    },
    showApproveUserPanel() {
      this.approveModel.showPanel = true;
      if (this.model.username) {
        this.approveModel.username = this.model.username;
        this.approveModel.authMode = this.model.authMode;
      }
      this.showButtons = false;
      this.commentModel.showPanel = false;
    },
    showDenialCommentPanel(isNewComment) {
      this.showButtons = false;
      this.commentModel.requestStatus = userRequestStatuses.Denegada;
      this.commentModel.title = 'Razón de Denegación';
      this.commentModel.icon = 'fas fa-ban';
      this.commentModel.showPanel = true;
      if (isNewComment) {
        this.commentModel.comment = '';
      }

      this.approveModel.showPanel = false;
    },
    showCancelationCommentPanel(enablePanel, isNewComment) {
      if (this.model.userIsActive) {
        this.Toast(
          'Error',
          `No es posible cambiar la determinación ya que el usuario tiene la cuenta activa en sistema.`,
          'error'
        );
        return;
      }

      this.showButtons = false;
      this.commentModel.requestStatus = userRequestStatuses.Cancelada;
      this.commentModel.title = 'Razón de Cancelación';
      this.commentModel.icon = 'fas fa-times-circle';
      if (isNewComment) {
        this.commentModel.comment = '';
      }

      this.commentModel.showPanel = true;
      this.approveModel.showPanel = false;
      this.showCancelCommentPanel = enablePanel ?? false;
    },
    onApproveSave() {
      const changeRequestModel = {
        requestAccountUserId: this.model.id,
        statusId: userRequestStatuses.Aprobada,
        dateChange: this.dateobj.toLocaleString()
      };

      this.changeStatusHandler(changeRequestModel);
    },
    onApproveCancel() {
      this.approveModel.showPanel = false;
      this.approveModel.username = null;
      this.approveModel.authMode = null;
      this.showButtons = true;
    },
    onCommentSave(input) {
      const changeRequestModel = {
        requestAccountUserId: this.model.id,
        statusId: this.commentModel.requestStatus,
        reason: input,
        dateChange: this.dateobj.toLocaleString()
      };

      this.changeStatusHandler(changeRequestModel);
      this.onCommentCancel();
    },
    onCommentCancel() {
      this.commentModel.requestStatus = null;
      this.commentModel.title = '';
      this.commentModel.icon = '';
      this.commentModel.showPanel = false;
      this.showButtons = true;
      this.showCancelCommentPanel = false;

      this.getRequestInfo();
    },
    async changeStatusHandler(model) {
      let isApprovingMode = false;

      let verbs = {
        confirmQuestion: null,
        successMsg: null,
      };

      switch (model.statusId) {
        case userRequestStatuses.Aprobada:
          verbs.confirmQuestion = 'aprobar';
          verbs.successMsg = 'aprobada';
          isApprovingMode = true;
          break;
        case userRequestStatuses.Cancelada:
          verbs.confirmQuestion = 'cancelar';
          verbs.successMsg = 'cancelada';
          break;
        case userRequestStatuses.Denegada:
          verbs.confirmQuestion = 'denegar';
          verbs.successMsg = 'denegada';
          break;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea ${verbs.confirmQuestion} la solicitud de la creación de usuario?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      if (!isApprovingMode) {
        await this.changeRequestStatus(model, verbs.successMsg);
        return;
      } else {
        await addUserFromRequest(
          model.requestAccountUserId,
          this.approveModel.username,
          this.approveModel.authMode
        )
          .then(async ({ data }) => {
            model.createdUserId = data.userId;
            await eduespService.createUserProfile(data);

            if (data.requireDETicketsProfile) {
              const profile = {
                userId: data.userId,
                firstName: data.firstName,
                lastName1: data.lastPaternalName,
                lastName2: data.lastMaternalName,
                deptIds: data.deptIds,
                socialSecurityNumber: data.socialSecurityNumber,
                isActiveDirectoyUser: data.isActiveDirectoryUser,
                email: data.email,
                createsCasesOnlyForSelf: false,
                applicationId: apps.detickets,
              };
              await deticketsService.createUserProfile(profile);
            }
            await this.changeRequestStatus(model, verbs.successMsg);
          })
          .catch((err) => {
            const errors = err.response?.data;
            const inputErrors = { approveUsername: [] };

            errors.value.forEach((error) => {
              if (error.value == 6) {
                inputErrors.approveUsername.push(
                  'El nombre de usuario ya existe.'
                );
              }
            });
            this.$refs.approveUserRef.setErrors(inputErrors);
          });
      }
    },
    async changeRequestStatus(model, verb) {
      await _changeRequestStatus(model)
        .then((data) => {
          if (data.response && data.response.status != 200) {
            this.Toast(
              'Error',
              data.response?.data?.message ?? 'Error con la solicitud',
              'error'
            );
          } else {
            this.Toast(
              'Proceso Exitoso',
              `La solicitud ha sido ${verb} exitosamente.`,
              'success'
            );
          }
        })
        .then(() => this.getRequestInfo());
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/sass/config/_colors.scss';

.account-request ::v-deep {
  font-weight: normal;

  .ar_section-title {
    margin: 1.5rem 0 !important;
    margin-left: -0.25rem !important;
    &-info {
      margin-top: 0 !important;
      font-size: 1rem;
    }
    &-container {
      display: inline-flex;
      align-items: center;
      background: map-get($colors, 'orange-light');
      padding: 0.1rem 1rem 0.1rem 0.2rem !important;
      .dot {
        display: flex;
        width: 28px;
        height: 28px;
        .title-icon {
          font-size: 0.8rem;
        }
      }
    }
  }

  .readonly-label {
    display: block;
    font-size: 14px;
    color: #727272;
    margin-bottom: 0;
  }
  .input-display {
    & > label {
      @extend .readonly-label;
    }
  }
}
</style>
